import React from 'react';

export const FlexColumn = ({ className, id, children, onClick, ...props }) => (
  <div className={`flex flex-col ${className}`} id={id} onClick={onClick} {...props}>
    {children}
  </div>
);
